import { Box } from '@mui/material'
import {
  ProGroupcalIcon,
  ProRed,
  ProRedIcon,
  ProYellowIcon
} from 'assets/icons'
import { PopupRowTitle } from 'components/popups/styled'
import i18n from 'i18n'
import { ReactNode } from 'react'
import { theme } from 'theme'
import { Tier } from 'utils/api/accounts'
import { is24meApp } from 'utils/appType'

import { ProBadgeBox } from './styled'

interface ProBadgeProps {
  title: string | ReactNode
  neededTier?: Tier
}

const proIconSize = is24meApp() ? 20 : 14
const proBadgeBox = is24meApp() ? 20 : 14

export default function ProBadge(props: ProBadgeProps) {
  return (
    <ProBadgeBox
      badgesize={proBadgeBox}
      flexDirection={'row'}
      paddingRight={i18n.dir() === 'ltr' ? '16px' : undefined}
      paddingLeft={i18n.dir() === 'ltr' ? undefined : '16px'}
    >
      <PopupRowTitle style={{ position: 'relative' }}>
        {props.title}
        <div
          style={{
            right: i18n.dir() === 'ltr' ? -(proBadgeBox - 2) : undefined,
            left: i18n.dir() === 'ltr' ? undefined : -(proBadgeBox - 2),
            top: -8,
            position: 'absolute'
          }}
        >
          {is24meApp() ? <ProYellowIcon /> : <ProGroupcalIcon />}
        </div>
      </PopupRowTitle>
    </ProBadgeBox>
  )
}

interface ProBadgeContainerProps {
  children: ReactNode
}

export function ProBadgeContainer(props: ProBadgeContainerProps) {
  return (
    <Box display={'flex'}>
      {props.children}
      <div style={{ left: -4, bottom: 4, position: 'relative' }}>
        <ProGroupcalIcon width={proIconSize} height={proIconSize} />
      </div>
    </Box>
  )
}
